import * as React from "react";

function SvgClose({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          d="M6.446 5.397l.084.073L12 10.939l5.47-5.47a.75.75 0 011.133.977l-.073.084L13.061 12l5.47 5.47a.75.75 0 01-.977 1.133l-.084-.073L12 13.061l-5.47 5.47a.75.75 0 01-1.133-.977l.073-.084L10.939 12l-5.47-5.47a.75.75 0 01.977-1.133z"
        />
      </g>
    </svg>
  );
}

export default SvgClose;
